/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Models
import { ApiResponse, PriceConfigPriceType } from '@core/models';
// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Services
import { ApiService } from 'app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PriceConfigPriceTypeService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  updatePriceConfigPriceType(
    priceType: Partial<PriceConfigPriceType>,
    updatedBy: string
  ): Observable<ApiResponse<PriceConfigPriceType>> {
    return this.http
      .put<ApiResponse<PriceConfigPriceType>>(`${this.apiService.superAdminApi}/price-config-price-type`, {
        priceType,
        updatedBy,
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  batchUpdatePriceConfigPriceType(
    priceTypes: Partial<PriceConfigPriceType[]>,
    updatedBy: string
  ): Observable<ApiResponse<PriceConfigPriceType[]>> {
    return this.http
      .put<ApiResponse<PriceConfigPriceType[]>>(`${this.apiService.superAdminApi}/price-config-price-type/batch`, {
        priceTypes,
        updatedBy,
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
